// Simple content for demo
module.exports = {
  shape: 'general--audio',
};
